<template>
  <div style="width: 100%;">



     <HeaderMain
      :hideOrderButton="true"
      title="Посты"
    /> 



  <div class="calendar-app">
   
    <!-- Левая панель с заказами и мастерами -->
    <div class="sidebar">
      <div class="orders-list">
        <h3>Список заказов</h3>
        <!-- Фильтры заказов -->
        <div class="filter-buttons">
          <button
            :class="{ active: activeStatus === '' }"
            @click="filterByStatus('')"
            style="background:#d6eaff"
          >Все</button>
          <button
            v-for="(status, index) in visibleFilterStatuses"
            :key="status.value"
            :class="{ active: activeStatus === status.value }"
            @click="filterByStatus(status.value)"
            :style="{ background: status.color }"
          >{{ status.label }}</button>
          <button
            v-if="!showAllFilterButtons && filterStatuses.length > 6"
            @click="showAllFilterButtons = true"
          >Показать ещё</button>
        </div>
        <!-- Список заказов -->
        <div
          class="order-item"
          v-for="order in orders"
          :key="order.id"
          :draggable="!order.scheduledDetails"
          @dragstart="onDragStartFromList($event, order)"
        >
          <template v-if="order.scheduledDetails">
            <div class="order_name">Заказ №{{ order.number }}</div>
            <div class="order_scheduled_date">
              Дата: {{ order.scheduledDetails.date }}
            </div>
            <div class="order_scheduled_time">
              Время: {{ formatTime(order.scheduledDetails.startTime) }} - {{ formatTime(order.scheduledDetails.endTime) }}
            </div>
            <div class="order_scheduled_post">
              Пост: {{ getPostName(order.scheduledDetails.postId) }}
            </div>
            <div class="order_scheduled_master" v-if="order.scheduledDetails.master">
              Мастер: {{ order.scheduledDetails.master.name }}
            </div>
          </template>
          <template v-else>
            <div class="orderHead">
              <div class="order_name">{{ order.number }}</div>
              <div class="order_data">{{ order.createdAt }}</div>
            </div>
            <div class="order_fname">{{ order.firstName }}</div>
            <div class="order_commtent" v-if="order.managerComment">Комметарий менеджера: {{ order.managerComment }}</div>
            <div class="order_client">{{ order.phone }}</div>
            <div class="order_comment" v-if="order.customerComment">
              {{ order.customerComment }}
            </div>
          </template>
        </div>
      </div>
      <div class="masters-list">
        <h3>Мастера</h3>
        <div
          class="master-item"
          v-for="master in masters"
          :key="master.id"
          draggable="true"
          @dragstart="onDragStartMaster($event, master)"
        >
          {{ master.name }}
        </div>
      </div>
    </div>

    <!-- Календарь -->
    <div class="calendar-container" ref="calendarContainer">
      <div class="days-header">
        <div
          class="day-header"
          v-for="day in daysToShow"
          :key="formatDate(day)"
          :class="{ 'current-day': formatDate(day) === formatDate(currentDate) }"
        >{{ formatDate(day) }}</div>
      </div>
      <div class="days-body" @wheel="handleDaysBodyWheel">
        <div
          class="day-column"
          v-for="day in daysToShow"
          :key="formatDate(day)"
          :class="{ 'current-day': formatDate(day) === formatDate(currentDate) }"
        >
          <div class="time-column">
            <div
              class="time-slot-label"
              v-for="slot in timeSlots.slice(0, timeSlots.length - 1)"
              :key="slot"
            >{{ formatTime(slot) }}</div>
          </div>
          <div class="posts-container">
            <div
              class="post-column"
              v-for="post in posts"
              :key="post.id"
              @dragover.prevent
              @drop="onDropInColumn($event, day, post)"
            >
              <div
                class="time-slot-grid"
                v-for="slot in timeSlots.slice(0, timeSlots.length - 1)"
                :key="slot"
                :style="{ height: cellHeight + 'px' }"
              ></div>
              <!-- Назначенные заказы для данного поста -->
              <div
                v-for="(item, idx) in scheduledOrders.filter(o => o.date === formatDate(day) && o.postId === post.id)"
                :key="(item.order && item.order.id) ? item.order.id + '-' + idx : idx"
                class="order-block"
                :style="getOrderStyle(item)"
                draggable="true"
                @dragstart="onDragStartScheduled($event, item)"
                @dragover.prevent
                @drop="onDropOnOrder($event, item)"
              >
                <div class="order-content">
                  <div>
                    Время: {{ formatTime(item.startTime) }} - {{ formatTime(item.endTime) }}
                  </div>
                  <div>
                    Заказ №{{ item.order ? item.order.number : 'Без заказа' }}
                  </div>
                  <div v-if="item.master">
                    Мастер: {{ item.master.name }}
                  </div>
                  <div v-if="item.order && item.order.customFields && item.order.customFields.marka_avto">
                    Машина: {{ item.order.customFields.marka_avto }}
                  </div>
                </div>
                <!-- Кнопка удаления заказа из календаря -->
                <div class="delete-btn" @click.stop="deleteOrder(item.order)">×</div>
                <div class="resize-handle" @mousedown.stop.prevent="initResize($event, item)"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="calendar-nav">
        <button @click="goToPreviousDay">Предыдущий день</button>
        <span>{{ formatDate(currentDate) }}</span>
        <button @click="goToNextDay">Следующий день</button>
      </div>
    </div>
  </div>
  </div>
</template>

<script>import { ORDERS_API_BASE } from '@/config/api';

import axios from 'axios';

import HeaderMain from '@/components/HeaderMain.vue'

export default {
  name: 'CalendarComponent',
  components: { HeaderMain },
  data() {
    return {
      orders: [],
      masters: [
        { id: 'm1', name: 'Ромашкин' },
        { id: 'm2', name: 'Одуванчиков' },
        { id: 'm3', name: 'Кактусов' },
      ],
      posts: [
        { id: 'post1', name: 'Пост 1' },
        { id: 'post2', name: 'Пост 2' },
        { id: 'post3', name: 'Пост 3' },
      ],
      cellHeight: 30,
      currentDate: new Date(),
      scheduledOrders: [],
      draggedOrder: null,
      draggedScheduledItem: null,
      draggedMaster: null,
      resizingItem: null,
      resizeStartY: 0,
      initialDuration: 0,
      activeStatus: '',
      filterStatuses: [
        { label: 'Авто ожидает ремонта (ждет зч/очередь)', value: 'stoffnksajn12212', color: '#f5f5dc' },
        { label: 'Авто в ремонте, в цеху', value: 'avto-v-remonte-v-tsekhu', color: '#ffeb3b' },
      ],
      showAllFilterButtons: false,
      apiEndpoint: ORDERS_API_BASE + '/sto_orders.php',
      scheduledOrdersApi: {
        get: 'https://manager.1akb.by/getScheduledOrders',
        post: 'https://manager.1akb.by/postScheduledOrders',
        put: 'https://manager.1akb.by/putScheduledOrders',
        delete: 'https://manager.1akb.by/delScheduledOrders'
      },
      page: 1,
      perPage: 50,
    }
  },
  computed: {
    timeSlots() {
      const slots = [];
      for (let t = 9; t <= 18; t += 0.5) {
        slots.push(Number(t.toFixed(1)));
      }
      return slots;
    },
    daysToShow() {
      const current = new Date(this.currentDate);
      const next = new Date(this.currentDate);
      next.setDate(current.getDate() + 1);
      const next2 = new Date(this.currentDate);
      next2.setDate(current.getDate() + 2);
      return [current, next, next2];
    },
    visibleFilterStatuses() {
      return this.showAllFilterButtons
        ? this.filterStatuses
        : this.filterStatuses.slice(0, 6);
    }
  },
  methods: {
    formatDate(date) {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    formatTime(time) {
      const hour = Math.floor(time);
      const minutes = (time % 1) ? '30' : '00';
      return `${hour.toString().padStart(2, '0')}:${minutes}`;
    },
    // Возвращает название поста по его идентификатору
    getPostName(postId) {
      const post = this.posts.find(p => p.id === postId);
      return post ? post.name : postId;
    },
    // Обновление заказов из списка, если для них найдены данные из назначенных заказов
    updateOrdersWithScheduledDetails() {
      this.scheduledOrders.forEach(sched => {
        if (sched.order && sched.order.id) {
          const order = this.orders.find(o => o.id === sched.order.id);
          if (order) {
            order.scheduledDetails = {
              date: sched.date,
              postId: sched.postId,
              startTime: sched.startTime,
              endTime: sched.endTime,
              master: sched.master
            };
          }
        }
      });
    },
    getMaxAvailableDuration(date, postId, startTime, excludeItem = null) {
      let maxDuration = 18 - startTime;
      const nextOrders = this.scheduledOrders
        .filter(item => item.date === date && item.postId === postId && item.startTime > startTime && item !== excludeItem)
        .sort((a, b) => a.startTime - b.startTime);
      if (nextOrders.length > 0) {
        const gap = nextOrders[0].startTime - startTime;
        maxDuration = Math.min(maxDuration, gap);
      }
      return maxDuration;
    },
    isTimeSlotAvailable(date, postId, startTime, duration, excludeItem = null) {
      const newEnd = startTime + duration;
      return !this.scheduledOrders.some(item => {
        if (item.date !== date || item.postId !== postId) return false;
        if (excludeItem && item === excludeItem) return false;
        const itemStart = item.startTime;
        const itemEnd = item.endTime;
        return startTime < itemEnd && itemStart < newEnd;
      });
    },
    onDragStartFromList(e, order) {
      // Если заказ уже назначен, запрещаем перетаскивание из левого списка
      if (order.scheduledDetails) {
        e.preventDefault();
        return;
      }
      this.draggedOrder = order;
      e.dataTransfer.effectAllowed = 'move';
      e.dataTransfer.setData('orderId', order.id);
    },
    onDragStartScheduled(e, item) {
      this.draggedScheduledItem = item;
      e.dataTransfer.effectAllowed = 'move';
      e.dataTransfer.setData('orderId', (item.order && item.order.id) ? item.order.id : '');
    },
    onDragStartMaster(e, master) {
      this.draggedMaster = master;
      e.dataTransfer.effectAllowed = 'move';
      e.dataTransfer.setData('masterId', master.id);
    },
    onDropInColumn(e, dropDay, post) {
  const rect = e.currentTarget.getBoundingClientRect();
  const offsetY = e.clientY - rect.top;
  let slotIndex = Math.floor(offsetY / this.cellHeight);
  if (slotIndex < 0) slotIndex = 0;
  if (slotIndex >= this.timeSlots.length - 1) slotIndex = this.timeSlots.length - 2;
  const startTime = this.timeSlots[slotIndex];
  const dropDate = this.formatDate(dropDay);
  let desiredDuration = this.draggedOrder
    ? 1
    : (this.draggedScheduledItem.endTime - this.draggedScheduledItem.startTime);
  const maxDuration = this.getMaxAvailableDuration(dropDate, post.id, startTime, this.draggedScheduledItem);
  let orderDuration = Math.min(desiredDuration, maxDuration);
  if (orderDuration < 0.5) {
    alert("Нет свободного интервала для размещения заказа.");
    this.draggedOrder = null;
    this.draggedScheduledItem = null;
    return;
  }
  let orderId = this.draggedOrder
    ? this.draggedOrder.id
    : (this.draggedScheduledItem.order && this.draggedScheduledItem.order.id ? this.draggedScheduledItem.order.id : null);
  if (orderId) {
    if (
      (this.draggedOrder && this.scheduledOrders.some(item => item.order && item.order.id === orderId && item.date === dropDate)) ||
      (this.draggedScheduledItem && dropDate !== this.draggedScheduledItem.date &&
       this.scheduledOrders.some(item => item.order && item.order.id === orderId && item.date === dropDate))
    ) {
      alert("Нельзя создавать копию заказа: заказ уже существует в выбранный день.");
      this.draggedOrder = null;
      this.draggedScheduledItem = null;
      return;
    }
  }

  if (this.draggedOrder) {
    if (!this.isTimeSlotAvailable(dropDate, post.id, startTime, orderDuration)) {
      alert("В это время уже назначен заказ.");
      this.draggedOrder = null;
      return;
    }
    const newScheduledOrder = {
      id: Date.now().toString(),
      order: this.draggedOrder,
      date: dropDate,
      postId: post.id,
      startTime: startTime,
      endTime: startTime + orderDuration,
      origin: dropDate,
      master: null,
    };
    this.scheduledOrders.push(newScheduledOrder);
    // Реактивно обновляем заказ в orders, устанавливая новые данные (в том числе postId)
    const orderIndex = this.orders.findIndex(o => o.id === this.draggedOrder.id);
    if (orderIndex !== -1) {
      const updatedOrder = {
        ...this.orders[orderIndex],
        scheduledDetails: {
          date: dropDate,
          postId: post.id,
          startTime: startTime,
          endTime: startTime + orderDuration,
          master: null
        }
      };
      this.orders.splice(orderIndex, 1, updatedOrder);
    }
    this.saveScheduledOrder(newScheduledOrder);
    this.draggedOrder = null;
  } else if (this.draggedScheduledItem) {
    if (this.draggedScheduledItem.date === dropDate) {
      if (!this.isTimeSlotAvailable(dropDate, post.id, startTime, orderDuration, this.draggedScheduledItem)) {
        alert("В это время уже назначен заказ.");
        this.draggedScheduledItem = null;
        return;
      }
      // Обновляем данные уже назначенного заказа
      this.draggedScheduledItem.postId = post.id;
      this.draggedScheduledItem.startTime = startTime;
      this.draggedScheduledItem.endTime = startTime + orderDuration;
      // Реактивное обновление заказа в списке orders
      const orderIndex = this.orders.findIndex(o => o.id === this.draggedScheduledItem.order.id);
      if (orderIndex !== -1) {
        const updatedOrder = {
          ...this.orders[orderIndex],
          scheduledDetails: {
            date: dropDate,
            postId: post.id,
            startTime: startTime,
            endTime: startTime + orderDuration,
            master: this.draggedScheduledItem.master
          }
        };
        this.orders.splice(orderIndex, 1, updatedOrder);
      }
      this.updateScheduledOrder(this.draggedScheduledItem);
    } else {
      if (!this.isTimeSlotAvailable(dropDate, post.id, startTime, orderDuration)) {
        alert("В это время уже назначен заказ.");
        this.draggedScheduledItem = null;
        return;
      }
      if (this.draggedScheduledItem.origin === dropDate) {
        alert("Нельзя переместить копию обратно на исходный день.");
        this.draggedScheduledItem = null;
        return;
      }
      const newCopy = {
        id: Date.now().toString(),
        order: this.draggedScheduledItem.order,
        date: dropDate,
        postId: post.id,
        startTime: startTime,
        endTime: startTime + orderDuration,
        origin: this.draggedScheduledItem.origin,
        master: this.draggedScheduledItem.master,
      };
      this.scheduledOrders.push(newCopy);
      // Если требуется, можно также обновить заказ в orders (для копии обновляем scheduledDetails)
      const orderIndex = this.orders.findIndex(o => o.id === this.draggedScheduledItem.order.id);
      if (orderIndex !== -1) {
        const updatedOrder = {
          ...this.orders[orderIndex],
          scheduledDetails: {
            date: dropDate,
            postId: post.id,
            startTime: startTime,
            endTime: startTime + orderDuration,
            master: this.draggedScheduledItem.master,
          }
        };
        this.orders.splice(orderIndex, 1, updatedOrder);
      }
      this.saveScheduledOrder(newCopy);
    }
    this.draggedScheduledItem = null;
  }
}
,
    getOrderStyle(item) {
      const intervalsFromStart = (item.startTime - 9) * 2;
      const topOffset = intervalsFromStart * this.cellHeight;
      const intervalsDuration = (item.endTime - item.startTime) * 2;
      const height = intervalsDuration * this.cellHeight;
      return {
        position: 'absolute',
        top: topOffset + 'px',
        left: '5px',
        right: '5px',
        height: (height - 5) + 'px',
        backgroundColor: 'rgba(0, 123, 255, 0.88)',
        border: '1px solid #007bff',
        borderRadius: '4px',
        cursor: 'move',
        boxSizing: 'border-box'
      };
    },
    onDropOnOrder(e, item) {
      if (this.draggedMaster) {
        this.$set(item, 'master', this.draggedMaster);
        this.updateScheduledOrder(item);
        // Если заказ назначен, также обновляем его отображение в списке заказов
        if (item.order && item.order.id) {
          const orderToUpdate = this.orders.find(o => o.id === item.order.id);
          if (orderToUpdate && orderToUpdate.scheduledDetails) {
            orderToUpdate.scheduledDetails.master = this.draggedMaster;
          }
        }
        this.draggedMaster = null;
      }
    },
    initResize(e, item) {
      this.resizingItem = item;
      this.resizeStartY = e.clientY;
      this.initialDuration = item.endTime - item.startTime;
      document.addEventListener('mousemove', this.onResizing);
      document.addEventListener('mouseup', this.stopResizing);
    },
    onResizing(e) {
      if (!this.resizingItem) return;
      const diff = e.clientY - this.resizeStartY;
      const additional = diff >= 0
        ? Math.floor(diff / this.cellHeight) / 2
        : Math.ceil(diff / this.cellHeight) / 2;
      let newDuration = this.initialDuration + additional;
      if (newDuration < 0.5) newDuration = 0.5;
      const maxByTime = 18 - this.resizingItem.startTime;
      const sameGroup = this.scheduledOrders
        .filter(o =>
          o.date === this.resizingItem.date &&
          o.postId === this.resizingItem.postId &&
          o.startTime > this.resizingItem.startTime
        )
        .sort((a, b) => a.startTime - b.startTime);
      let maxDuration = maxByTime;
      if (sameGroup.length > 0) {
        maxDuration = Math.min(maxByTime, sameGroup[0].startTime - this.resizingItem.startTime);
      }
      if (newDuration > maxDuration) newDuration = maxDuration;
      this.resizingItem.endTime = this.resizingItem.startTime + newDuration;
    },
    stopResizing() {
  if (this.resizingItem) {
    // Обновляем заказ на сервере
    this.updateScheduledOrder(this.resizingItem);
    // Готовим новый объект scheduledDetails с обновлённым временем
    const newDetails = {
      date: this.resizingItem.date,
      postId: this.resizingItem.postId,
      startTime: this.resizingItem.startTime,
      endTime: this.resizingItem.endTime,
      master: this.resizingItem.master,
    };
    // Находим заказ в списке orders и заменяем его на новый объект,
    // чтобы Vue отследил изменения
    const orderIndex = this.orders.findIndex(o => o.id === this.resizingItem.order.id);
    if (orderIndex !== -1) {
      this.orders.splice(orderIndex, 1, {
        ...this.orders[orderIndex],
        scheduledDetails: newDetails
      });
    }
  }
  this.resizingItem = null;
  document.removeEventListener('mousemove', this.onResizing);
  document.removeEventListener('mouseup', this.stopResizing);
}
,
    goToNextDay() {
      const next = new Date(this.currentDate);
      next.setDate(next.getDate() + 1);
      this.currentDate = next;
    },
    goToPreviousDay() {
      const prev = new Date(this.currentDate);
      prev.setDate(prev.getDate() - 1);
      this.currentDate = prev;
    },
    // Удаляем заказ из календаря. Если заказ уже назначен – его удаление из левого списка не производится.
deleteOrder(order) {
  // Находим все назначенные задачи для данного заказа
  const scheduled = this.scheduledOrders.filter(item => item.order && item.order.id === order.id);
  scheduled.forEach(item => {
    this.deleteScheduledOrder(item.id);
  });
  // Удаляем назначение из календаря
  this.scheduledOrders = this.scheduledOrders.filter(item => !(item.order && item.order.id === order.id));
  
  // Очищаем данные о назначении у заказа в сайдбаре
  const orderInList = this.orders.find(o => o.id === order.id);
  if (orderInList) {
    orderInList.scheduledDetails = null;
  }
},
    filterByStatus(statusValue) {
      this.activeStatus = statusValue;
      if (!this.showAllFilterButtons) {
        this.showAllFilterButtons = false;
      }
      this.fetchOrders();
    },
    fetchOrders() {
      const filterParams = { sites: ['sto-prodaza'] };
      if (this.activeStatus) {
        filterParams.extendedStatus = [this.activeStatus];
      }
      axios.get(this.apiEndpoint, {
        params: {
          page: this.page,
          per_page: this.perPage,
          filter: filterParams
        }
      })
      .then(response => {
        if (response.data.orders) {
          this.orders = response.data.orders;
          console.log(this.orders);
          // Если уже загружены назначенные заказы – синхронизируем их с orders
          if (this.scheduledOrders.length) {
            this.updateOrdersWithScheduledDetails();
          }
        } else {
          console.error("Ошибка получения заказов", response.data);
        }
      })
      .catch(error => {
        console.error("Ошибка запроса к API", error);
      });
    },
    fetchScheduledOrders() {
      axios.get(this.scheduledOrdersApi.get)
      .then(response => {
        if (Array.isArray(response.data)) {
          // Преобразуем полученные данные: восстанавливаем объект заказа из order_id и order_data
          this.scheduledOrders = response.data.map(item => ({
            ...item,
            order: item.order_data ? JSON.parse(item.order_data) : { id: item.order_id }
          }));
          // Синхронизируем назначенные заказы с основным списком orders
          if (this.orders.length) {
            this.updateOrdersWithScheduledDetails();
          }
        } else {
          console.error("Неверный формат данных назначенных заказов", response.data);
        }
      })
      .catch(error => {
        console.error("Ошибка получения назначенных заказов", error);
      });
    },
    saveScheduledOrder(orderData) {
      const payload = {
        id: orderData.id,
        order: orderData.order, // сервер сохранит order.id в order_id и полный объект в order_data
        date: orderData.date,
        postId: orderData.postId,
        startTime: orderData.startTime,
        endTime: orderData.endTime,
        origin: orderData.origin,
        master: orderData.master
      };
      axios.post(this.scheduledOrdersApi.post, payload)
      .then(response => {
        console.log("Заказ сохранён", response.data);
      })
      .catch(error => {
        console.error("Ошибка сохранения заказа", error);
      });
    },
    updateScheduledOrder(orderData) {
      const payload = {
        date: orderData.date,
        postId: orderData.postId,
        startTime: orderData.startTime,
        endTime: orderData.endTime,
        master: orderData.master
      };
      axios.put(`${this.scheduledOrdersApi.put}/${orderData.id}`, payload)
      .then(response => {
        console.log("Заказ обновлён", response.data);
      })
      .catch(error => {
        console.error("Ошибка обновления заказа", error);
      });
    },
    deleteScheduledOrder(orderId) {
      axios.delete(`${this.scheduledOrdersApi.delete}/${orderId}`)
      .then(response => {
        console.log("Заказ удалён", response.data);
      })
      .catch(error => {
        console.error("Ошибка удаления заказа", error);
      });
    },
    handleDaysBodyWheel(e) {
      e.preventDefault();
      if (e.deltaY > 0) {
        this.goToNextDay();
      } else if (e.deltaY < 0) {
        this.goToPreviousDay();
      }
    }
  },
  mounted() {
    this.fetchOrders();
    this.fetchScheduledOrders();
  }
}
</script>

<style scoped>
/* Пример стилей – настройте по необходимости */
.calendar-app {
  display: flex;
}
.sidebar {
  width: 300px;
  border-right: 1px solid #ccc;
  padding: 10px;
}
.orders-list .order-item {
  padding: 5px;
  margin-bottom: 5px;
  background: #fff;
  cursor: grab;
  border: 1px solid #eee;
    margin: 12px 0px 12px 0px;
}
.orders-list .order-item[draggable="false"] {
  cursor: default;
  opacity: 0.7;
}
.masters-list .master-item {
  border: 1px solid #ddd;
  padding: 5px;
  margin-bottom: 5px;
  background: #f1f1f1;
  cursor: grab;
}
.calendar-container {
  flex: 1;
  position: relative;
  padding: 10px;
}
.day-column {
  position: relative;
  border-right: 1px solid #eee;
  float: left;
  width: calc(100% / 3);
  height: 600px;
}
.time-column {
  position: absolute;
  left: 0;
  top: 0;
  width: 50px;
}
.time-slot-label {
  height: 30px;
  font-size: 12px;
  text-align: right;
  padding-right: 5px;
}
.posts-container {
  margin-left: 50px;
  position: relative;
  height: 100%;
}
.order-block {
  position: absolute;
  background: rgba(0,123,255,0.88);
  color: #fff;
  overflow: hidden;
}
.delete-btn {
  position: absolute;
  top: 2px;
  right: 2px;
  cursor: pointer;
  font-weight: bold;
}
.resize-handle {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 5px;
  cursor: ns-resize;
  background: rgba(0,0,0,0.2);
}
.calendar-nav {
  clear: both;
  padding-top: 10px;
  text-align: center;
}
</style>



<style scoped>
.calendar-app {
  display: flex;
  height: 100vh;
  background: #f5f5f5;
  width: 100%;
  border-right: solid 1px #cccccc;
}
.sidebar {
  width: 255px;
  padding: 10px;
  border-right: 1px solid #ccc;
  overflow-y: auto;
  background: #fff;
}
.orders-list {
  margin-bottom: 20px;
}
.filter-buttons {
  margin-bottom: 10px;
  display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.filter-buttons button {
    margin: 2px;
    padding: 4px 4px;
    border: 1px solid #007bff29;
    border-radius: 4px;
    background: #fff;
    cursor: pointer;
    max-width: 96px;
    overflow: hidden;
    font-size: 10px;
    text-align: left;
    line-height: 10px;
    height: 28px;
    min-width: 24px;
}
.filter-buttons button.active {
  background: #007bff!important;
  color: #fff;
}
.order-item {
  background: #fff;
  margin-bottom: 10px;
  padding: 8px;
  border-radius: 4px;
  cursor: grab;
}
.masters-list {
  border-top: 1px solid #ccc;
  padding-top: 10px;
}
.master-item {
  background: #e9ecef;
  margin-bottom: 10px;
  padding: 8px;
  border: 1px solid #adb5bd;
  border-radius: 4px;
  cursor: grab;
}
.calendar-container {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.days-header {
  display: flex;
  background: #eee;
  border-bottom: 1px solid #ccc;
  border-top: solid 1px #cccccc;
}
.day-header {
  flex: 1;
  text-align: center;
  padding: 8px;
  border-right: 1px solid #ccc;
  background: #e6eef6;
}
.day-header:last-child {
  border-right: none;
}
.days-body {
  display: flex;
  flex: 1;
  overflow-y: auto;
}
.day-column {
  flex: 1;
  border-right: 1px solid #ccc;
  position: relative;
  display: flex;
  flex-direction: row;
}
.day-column:last-child {
  border-right: none;
}
.current-day {
  background-color: #e0f8e0;
}
.time-column {
  width: 42px;
  border-right: 1px solid #ccc;
}
.time-slot-label {
  height: 30px;
  border-bottom: 1px solid #ccc;
  text-align: right;
  padding-right: 5px;
  line-height: 30px;
  box-sizing: border-box;
  font-size: 12px;
}
.orders-list h3 {
  font-size: 1.3rem;
}
.posts-container {
  flex: 1;
  display: flex;
  flex-direction: row;
}
.post-column {
  flex: 1;
  position: relative;
  border-left: 1px solid #ccc;
}
.post-column:first-child {
  border-left: none;
}
.time-slot-grid {
  height: 30px;
  border-bottom: 1px solid #ccc;
  box-sizing: border-box;
}
.order-block {
  position: absolute;
  box-sizing: border-box;
}
.order-content {
  padding: 5px;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 20px;
}
.order-content div {
  white-space: normal;
}
.delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  background: #ff4d4d;
  color: #fff;
  border-radius: 0 4px 0 4px;
  padding: 2px 5px;
  cursor: pointer;
  font-weight: bold;
}
.resize-handle {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 8px;
  background: rgba(0,0,0,0.2);
  cursor: ns-resize;
}
.calendar-nav {
      padding: 10px;
    border-top: 1px solid #ccc;
    text-align: center;
    background: rgb(27 138 251 / 7%);
    border-bottom: solid 1px #ccc;
}
.calendar-nav button {
    margin: 0 10px;
    padding: 5px 10px;
    background: #166ec9;
    border: 0px;
    border-radius: 4px;
    color: #fff;
}

.content-container .sticky-saved-orders {
  display: none!important;
}

.order_name {
  font-size: 12px;
    font-weight: 800;
    
}

.order_client {
      font-size: 14px;
    font-weight: 800;
}



.header-main{
    display: flex;
    empty-cells: hide;
    padding: 32px 0 24px;
    justify-content: space-between;
}




.header-main .hm-left {
    width: auto;
}

.header-main .hm-left, .header-main .hm-right {
    display: table-cell;
    float: none;
    vertical-align: top;
}





.hm-left h1 {
    font-size: 24px;
    font-weight: 500;
    letter-spacing: -.3px;
    line-height: 32px;
    margin-top: 10px;
}

.header-main__title:not(:last-child) {
    margin-right: 16px;
}


.btn_ms {
    margin-right: 15px;
    background: linear-gradient(180deg, #fea530, #e48e1e) !important;
    color: #ffffff;
    font-size: 16px;
    height: 25px;
    line-height: 24px;
    padding: 12px 24px;
}


.btn_md{
    font-size: 16px;
    height: 25px;
    line-height: 24px;
    padding: 12px 24px;
}


.btn-content {
    display: flex;
}

.btn-content_icon {
    margin-left: -8px;
}


.btn_ms.router-link-exact-active{
    margin-right: 15px;
    background: linear-gradient(180deg, #d4d4d4, #e6e6e6) !important;
    color: #000000;
    font-size: 16px;
    height: 25px;
    line-height: 24px;
    padding: 12px 24px;
}


.orderHead {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  border-bottom: 1px solid #ddd;
  font-size: 14px;
  font-weight: 500;
  color: #000;
}


.order_data {
  color: #888;
  font-size: 12px;
}

.order_fname {
  padding: 6px 12px;
  font-size: 13px;
  font-weight: 500;
  color: #000;
}

.order_commtent,
.order_comment {
  padding: 6px 12px;
  font-size: 11px;
  color: #000;
  margin-bottom: 6px;
  border-bottom: 1px solid #eee;
}

.order_client {
  padding: 6px 12px;
  font-size: 13px;
  color: #000;
}
</style>
